import VehicleService from "../services/web/vehicle-service.js";

export const getBrandModels = (search, callback) => {
    if (search === "") {
        callback([]);
    }
    VehicleService.getBrandModels(search).then((data) => {
        callback(data.map(({ id, text }) => ({ value: id, label: text })));
    })
};

export const getVehicleType = async () => {
    const response = await VehicleService.getVehicleType();

    return (response?.data ?? []).map(({ id, text }) => ({ value: id, label: text }));
};

export const getVehicleColors = async () => {
    const response = await VehicleService.getVehicleColor();

    return (response?.data ?? []).map(({ id, text }) => ({ value: id, label: text }));
};

export const getVehicleDataByPlate = async (plate) => {
    const normalizedPlate = String(plate ?? "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase();

    if (normalizedPlate.length < 7) return null;

    const response = await VehicleService.getVehicleByPlate(normalizedPlate);
    const vehicle = response?.data;

    if (!vehicle?.data) return null;

    let parsedData = {};

    try {
        parsedData = JSON.parse(vehicle.data);
    } catch (error) {
        console.error("Erro ao fazer parse dos dados do veículo:", error);
        return null;
    }

    return {
        plate: parsedData?.plate ?? normalizedPlate,
        city: parsedData?.city ?? "",
        type: parsedData?.type ? { value: parsedData.type, label: parsedData.type } : null,
        color: parsedData?.color ? { value: parsedData.color, label: parsedData.color } : null,
        chassis: parsedData?.chassis ?? "",
        renavam: parsedData?.renavam ?? "",
        numPorts: parsedData?.numPorts ?? "",
        modelYear: parsedData?.modelYear ?? "",
        fabricationYear: parsedData?.fabricationYear ?? "",
        nameOwner: parsedData?.nameOwner ?? "",
        possessor: parsedData?.possessor ?? "",
        brandModel: parsedData?.brandModel
            ? { value: parsedData.brandModel, label: parsedData.brandModel }
            : null,
        ownerPhone: parsedData?.ownerPhone ?? "",
        cpfCnpjOwner: parsedData?.cpfCnpjOwner ?? "",
        engineNumber: parsedData?.engineNumber ?? "",
        restrictions: parsedData?.restrictions ?? "",
        armoredVehicle: parsedData?.armoredVehicle ?? "",
        possessorPhone: parsedData?.possessorPhone ?? "",
        cpfCnpjPossessor: parsedData?.cpfCnpjPossessor ?? "",
        externalDt: vehicle?.external_dt ?? null,
        externalFields: vehicle?.external_fields ?? null,
        externalRestrictions: vehicle?.external_restrictions ?? null,
        lastUpdate: vehicle?.last_update ?? null,
        invalid: vehicle?.invalid ?? false,
    };
};